<template>
  <div class="h6 text-black-50 mb-1">
    {{ dateString }}
  </div>
</template>

<script>
import { datetimeMixin } from '@/mixins';

export default {
  name: 'MessageDate',

  mixins: [datetimeMixin],

  props: {
    date: {
      type: Date,
      default: () => new Date()
    }
  },

  computed: {
    dateString() {
      return this.date ? this.formatMessageDatetime(this.date) : '';
    }
  }
};
</script>

<style lang="scss" scoped></style>
